export const CANONICAL_URL = 'https://cryptomarketcap.com';

const REGEX_URL = /(\b(https?):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gi;
const isURL = (str: string) => REGEX_URL.test(str);
const isJunk = (str: string) => str.indexOf(' ') !== -1;

export function workableUrl(url: string): string | null {
	if (!url) return null;

	if (isJunk(url)) return null;
	if (!isURL(url)) return null;

	if (url.startsWith('https')) {
		return url;
	} else {
		return 'https://' + url;
	}
}
